import React from 'react';
import Hero from './components/affiliation/Hero';
import Main from './components/affiliation/Main';

const Affiliation = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Affiliation;